import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useSEO } from "@/lib/seo";
import { toHtml } from "@/components/RichTextEditor";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  useSEO({ title: post?.seo_title || post?.title, description: post?.seo_description || post?.excerpt, image: post?.featured_image });

  if (notFound) {
    return (
      <div className="min-h-screen grid place-items-center px-5" data-testid="post-not-found">
        <div className="text-center">
          <h1 className="font-display text-3xl text-forest">Article not found</h1>
          <Link to="/blog"><Button className="mt-4 rounded-full bg-forest text-cream">Back to Blog</Button></Link>
        </div>
      </div>
    );
  }
  if (!post) return <div className="min-h-screen grid place-items-center text-forest">Loading…</div>;

  return (
    <article className="pt-28 pb-24" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-2 text-forest/70 hover:text-gold transition-colors mb-8 text-sm" data-testid="back-to-blog">
          <ArrowLeft size={16} /> Back to Blog
        </Link>
        <Badge variant="outline" className="border-olive/40 text-olive mb-4">{post.category}</Badge>
        <h1 className="font-display text-4xl lg:text-5xl text-forest leading-tight">{post.title}</h1>
        <p className="text-sm text-muted-foreground mt-4">By {post.author}</p>
      </div>
      {post.featured_image && (
        <div className="max-w-4xl mx-auto px-5 lg:px-8 mt-8">
          <img src={post.featured_image} alt={post.title} className="w-full h-[420px] object-cover rounded-2xl shadow-xl" />
        </div>
      )}
      <div className="max-w-3xl mx-auto px-5 lg:px-8 mt-10">
        <div className="article-body text-forest/85" data-testid="post-content"
          dangerouslySetInnerHTML={{ __html: toHtml(post.content) }} />
      </div>
    </article>
  );
}
